import { createFileRoute } from '@tanstack/react-router'
import { DepotView } from '@features/stock/components/DepotView'
import { usePermissions } from '@lib/hooks/usePermissions'
import { requirePermission } from '@lib/permissions/guards'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'

export const Route = createFileRoute('/_app/stock/depots/$id/view')({
  beforeLoad: ({ context }) => {
    requirePermission(PERMISSIONS.STOCK.DEPOTS.VIEW, context)
  },
  component: ViewDepotComponent,
})

function ViewDepotComponent() {
  const { id } = Route.useParams()
  const { canView } = usePermissions()
    
  if (!canView('stock.depots.view')) {
    return <div className="p-6">Accès non autorisé</div>
  }

  return <DepotView id={Number(id)} />
}
